import { createSelector } from 'reselect';
import OfferSelectors from './offer';
import moment from 'moment';
import utils from '../utils';

class CartSelectors {

    static getItems = (state) => {
        return state.cart.items;
    }

    static getInstructions = (state) => state.cart.instructions;

    static getAccounts = (state) => state.myself.accounts;

    static showCart = createSelector(
        CartSelectors.getItems,
        OfferSelectors.getSelectedOffer,
        (items, offer) => {
            const filteredItems = items.filter(item => !item.addedToCart || item.editItem); // Show cart if non-cart items exist or editing cart items
            return Boolean(filteredItems.length > 0 && offer);
        }
    );
    /* This method is created to get response and show in main page the edit items feature for cart*/
    static editCart = createSelector(
        CartSelectors.getItems,
        OfferSelectors.getSelectedOffer,
        (items, offer) => {
            const filteredItems = items.filter(item => item.editItem); // checking if cart items edit was triggered.
            return Boolean(filteredItems.length > 0 && offer);
        }
    );


    static getSoldTo = createSelector(
        OfferSelectors.getSelectedOffer,
        (offer) => offer ? offer.account.soldTo : ""
    );


    static getProducts = createSelector(
        CartSelectors.getItems,
        OfferSelectors.getSelectedOffer,
        (items, offer) =>
            offer ? items.map((item) => offer.pricing[item.productIndex]) : []
    );

    static getCartContents = createSelector(
        CartSelectors.getItems,
        OfferSelectors.getSelectedOffer, OfferSelectors.getServersGroupedBySite,
        (items, offer, serversBySite) => {
            if (!offer) {
                return [];
            }
            return items.map((item) => {
                const pricing = offer.pricing[item.productIndex];
                const site = offer.sites[item.siteIndex];
                const server = serversBySite[item.siteIndex].servers[item.serverIndex]
                const cartId = item.cartId;
                if (item.cartId === '') item.addedToCart = false;
                else item.addedToCart = true;
                // Onlt Set item.itemDataChanged based on cartId if it's not already true
                item.itemDataChanged = item.itemDataChanged === true ? true : !cartId;
                let seatCost = 0;
                const soldTo = offer.account.soldTo
                let isTieredDiscountApplied = false
                const lowTierDiscountPct = pricing.lowTierDiscountPct;
        
                const usesEndDatePicker = offer.enterprise_deal || utils.isDateRangeSoldTO(soldTo) ||
                    offer.dailyPricingEnabled;
                const hasInvalidDateRange = usesEndDatePicker &&
                    (!item.startDate || !item.endDate ||
                        !moment(item.endDate).isAfter(moment(item.startDate))
                    );

                if (hasInvalidDateRange) {
                    // Keep invalid saved-cart items selectable, but do not attempt
                    // to calculate pricing for an end date before/equal to start date.
                    item.monthCount = 0;
                    item.dayCount = 0;
                } else if (utils.isDateRangeSoldTO(soldTo)) {

                    seatCost = pricing.monthly.find((p) => p.amount === 3).price;
                    const Endate = moment(item.endDate).clone().startOf('day');
                    const Stdate = moment(item.startDate).clone().startOf('day');

                    let monthCount, weekCount;
                    if (offer.weeklyPricingEnabled && pricing.weekly && pricing.weekly[0] && pricing.weekly[0].price) {
                        const fullMonths = Math.floor(Endate.diff(Stdate, 'months', true));
                        const afterMonths = Stdate.clone().add(fullMonths, 'months');
                        const remainingDays = Endate.diff(afterMonths, 'd');
                        const weeks = Math.ceil(remainingDays / 7);
                        monthCount = fullMonths;
                        weekCount = weeks;
                    } else {
                        monthCount = Math.ceil(Endate.diff(Stdate, 'months', true));
                        weekCount = 0;
                    }
                    item.monthCount = monthCount;
                    item.weekCount = weekCount;

                    const StDateAfterAdding3Mtns = Stdate.clone().add(3, 'months').subtract(1, 'day');
                    let diffBtwStEnDts = Endate.diff(StDateAfterAdding3Mtns, 'd');

                    diffBtwStEnDts = diffBtwStEnDts - (+process.env.DATE_RANGE_SOLDTO_ACCOUNTS_GRACEPERIOD + 1);
                    // check for previous transactions for # of licenses for this product if its tiered product
                    //Get previous eligible licenses from transactions
                    let annual_seat_cost = pricing.monthly.find(
                        (p) => p.amount === 12
                    ).price
                    if (pricing.tieredPricing) {
                        const eligibleLicenses = []
                        let prevLicensesSeats = 0
                        //eligibleTransactions = offer.transactions.filter(transaction => transaction.lincenses)
                        offer.transactions.forEach((transaction) => {
                            if (transaction.licenses) {
                                transaction.licenses.forEach((license) => {
                                    if (license.product.id === pricing.product.id && moment(license.validTo).startOf('day') > Stdate) {
                                        eligibleLicenses.push(license)
                                        prevLicensesSeats += license.seats
                                    }
                                })
                            }
                        })
                        if (prevLicensesSeats + item.seats >= 11) {
                            seatCost = Math.round(((1 - (lowTierDiscountPct / 100)) * seatCost))
                            isTieredDiscountApplied = true
                            annual_seat_cost = Math.round(((1 - (lowTierDiscountPct / 100)) * annual_seat_cost))
                        }
                    }

                    if (diffBtwStEnDts > 0) {
                        let remaningDaysCost = ((annual_seat_cost / 365) * diffBtwStEnDts);
                        seatCost = seatCost + remaningDaysCost;
                        seatCost = Math.round(seatCost);
                    }

                } else if (offer.enterprise_deal) {
                    const Endate = moment(item.endDate).clone().startOf('day');
                    const Stdate = moment(item.startDate).clone().startOf('day');

                    let monthCount, weekCount;
                    if (offer.weeklyPricingEnabled && pricing.weekly && pricing.weekly[0] && pricing.weekly[0].price) {
                        const fullMonths = Math.floor(Endate.diff(Stdate, 'months', true));
                        const afterMonths = Stdate.clone().add(fullMonths, 'months');
                        const remainingDays = Endate.diff(afterMonths, 'd');
                        const weeks = Math.ceil(remainingDays / 7);
                        monthCount = fullMonths;
                        weekCount = weeks;
                    } else {
                        monthCount = Math.ceil(Endate.diff(Stdate, 'months', true));
                        weekCount = 0;
                    }
                    item.monthCount = monthCount;
                    item.weekCount = weekCount;
                    if (monthCount > 0) {
                        seatCost = pricing.monthly.find((p) => p.amount === monthCount).price;
                    }
                } else if (offer.dailyPricingEnabled) {
                    const Endate = moment(item.endDate).clone().startOf('day');
                    const Stdate = moment(item.startDate).clone().startOf('day');
                    const stDateAfterAdding1Mtn = Stdate.clone().add(1, 'month');
                    let daysBetweenStartAndEndDate = Endate.diff(Stdate, 'd');
                    let daysInOneMonthPeriod = stDateAfterAdding1Mtn.diff(Stdate, 'd');
                    const monthsDiff = Math.ceil(Endate.diff(Stdate, 'months', true));
                    item.monthCount = monthsDiff;
                    item.dayCount = daysBetweenStartAndEndDate;
                    if (daysBetweenStartAndEndDate <= daysInOneMonthPeriod) {
                        seatCost = pricing.monthly.find((p) => p.amount === 1).price;
                    } else {
                        const dailyPrice = (pricing.monthly.find((p) => p.amount === 1).price * 12) / 365;
                        seatCost = daysBetweenStartAndEndDate * dailyPrice;
                    }
                } else if (item.monthCount > 0) {
                    seatCost += pricing.monthly.find(
                        (p) => p.amount === item.monthCount
                    ).price;

                }

                if (!hasInvalidDateRange && offer.weeklyPricingEnabled && item.weekCount > 0) {
                    seatCost += pricing.weekly[0].price * item.weekCount;
                }
                return {
                    ...item,
                    site,
                    server,
                    pricing,
                    seatCost,
                    subtotal: Math.round(item.seats * seatCost),
                    isTieredDiscountApplied,
                    cartId,
                };
            });
        }
    );

    static getTotal = createSelector(
        CartSelectors.getCartContents,
        (contents) => contents.filter((item) => item.addedToCart && !item.saveForLater).reduce((sum, item) => sum + item.subtotal, 0)
    );

    static getTempCartTotal = createSelector(
        CartSelectors.getCartContents,
        (contents) => contents.filter((item) => !item.addedToCart && !item.saveForLater).reduce((sum, item) => sum + item.subtotal, 0)
    );

    static hasOverspent = createSelector(
        CartSelectors.getTotal,
        OfferSelectors.getSelectedOffer,
        (total, offer) => total > (offer ? offer.balance : 0)
    );

    static hasTempCartOverspent = createSelector(
        CartSelectors.getTempCartTotal, CartSelectors.getTotal,
        OfferSelectors.getSelectedOffer,
        (tempTotal, total, offer) => (tempTotal + total) > (offer ? offer.balance : 0)
    );

    static readyForCheckout = createSelector(
        CartSelectors.getItems,
        CartSelectors.hasOverspent,
        (items, hasOverspent) => {
            const filteredItems = items.filter(item => item.addedToCart && !item.saveForLater); // Exclude items saved for later
            return filteredItems.reduce(
                (result, item) =>
                    result &&
                    item.startDate !== '' &&
                    !(item.startDate && item.endDate && !moment(item.endDate).isAfter(moment(item.startDate))) &&
                    item.serverIndex >= 0 &&
                    item.siteIndex >= 0 &&
                    item.seats > 0 &&
                    (item.monthCount > 0 || item.weekCount > 0),
                !hasOverspent && filteredItems.length > 0
            );
        }
    );

    static readyForaddToCart = createSelector(
        CartSelectors.getItems,
        CartSelectors.hasTempCartOverspent,
        OfferSelectors.getSelectedOffer,
        (items, hasOverspent, offer) => {
            const filteredItems = items.filter(item => !item.addedToCart);

            const result = filteredItems.reduce(
                (result, item) =>
                    result &&
                    !!item.startDate &&
                    item.startDate !== '' &&
                    !!item.endDate &&
                    item.endDate !== '' &&
                    moment(item.endDate).isAfter(moment(item.startDate)) &&
                    item.serverIndex >= 0 &&
                    item.siteIndex >= 0 &&
                    item.seats > 0 &&
                    (item.monthCount > 0 || item.weekCount > 0),
                !hasOverspent && filteredItems.length > 0
            );

            return result;
        }
    );

}

export default CartSelectors;



// WEBPACK FOOTER //
// ./app/selectors/cart.js